<script setup lang="ts">
  defineOptions({ name: 'LiveNowCardSkeleton' })

  import { createElementId } from '@common/core-layer/utils'

  import CPSkeleton from '@ui/components/CPSkeleton.vue'

  defineProps({
    idPrefix: {
      type: String,
      default: 'live-now',
    },
    index: {
      type: Number,
      default: 1,
    },
  })
</script>

<template>
  <article
    :id="createElementId(idPrefix, 'skeleton-card', String(index))"
    class="live-now-card-skeleton flex w-full flex-col overflow-hidden rounded-lg border border-solid border-[var(--cp-border-500)] bg-background"
    aria-hidden="true"
  >
    <div class="relative aspect-[2/1] w-full overflow-hidden rounded-t-lg">
      <CPSkeleton
        :id="createElementId(idPrefix, 'skeleton-cover', String(index))"
        type="image"
        width="100%"
        height="100%"
        :round="false"
        class="h-full w-full rounded-none"
      />
    </div>
    <div class="flex flex-1 flex-col gap-1.5 px-3 py-3">
      <CPSkeleton :id="createElementId(idPrefix, 'skeleton-badge', String(index))" type="text" width="4.5rem" height="1.25rem" />
      <CPSkeleton :id="createElementId(idPrefix, 'skeleton-title', String(index))" type="text" width="85%" height="1.25rem" />
      <CPSkeleton :id="createElementId(idPrefix, 'skeleton-place', String(index))" type="text" width="40%" height="1rem" />
      <CPSkeleton :id="createElementId(idPrefix, 'skeleton-progress', String(index))" type="text" width="55%" height="1rem" />
    </div>
  </article>
</template>
